///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API, CancelToken } from "../api/axios";
import { stringify } from "query-string";

let cancelGetShippersToken;

export const getShippers = searchTerm => {
  cancelGetShippersToken && cancelGetShippersToken("Cancelled By User");

  return API.get("api/v2.0/shippers/search?" + stringify({ searchTerm }), {
    cancelToken: new CancelToken(function executor(cancelToken) {
      cancelGetShippersToken = cancelToken;
    })
  });
};

export const getMainSalesRep = shipperId => {
  return API.get("api/v2.0/shippers/" + shipperId + "/main-sales-rep");
};

export const getFscForShipper = shipperId =>
  API.get("api/v1.0/shippers/" + shipperId + "/fuel-surcharge");

export const getShipperRatesStatus = shipperId =>
  API.get("api/v1.0/shippers/" + shipperId + "/shipper-rates-enabled");